import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { restoreStringifiedArray } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class CardBackTextures extends PlayerProperty<
    number[],
    {
        backcards: string;
    }
> {
    public readonly defaultValue: number[] = [2, 2, 2];

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            this.save(playerStateData).backcards !==
            playerEndpointData.backcards
        );
    }

    public restore(playerEndpointData: IPlayerData): number[] {
        return restoreStringifiedArray<number>(
            playerEndpointData.backcards,
            this.defaultValue
        );
    }

    public save(playerStateData: IPlayerState) {
        return { backcards: JSON.stringify(playerStateData.backcards) };
    }
}
